export default __webpack_public_path__ + "static/media/Portal_Question.97a343b0.svg";